import React from 'react';
import {Row, Col, Input } from 'antd'
import { useTranslation } from 'react-i18next';

const Domicilio = ({domicilio={}, record, actual}) => {
    const { t } = useTranslation();
    return (
        <div>
            <Row gutter={[32, 12]}>
              <Col span={record.type==='Entity' && domicilio.pais !== undefined ?4:5}>
                {t("messages.aml.country")}
                <Input readOnly value={domicilio.pais} className={actual && domicilio.pais !== actual.pais && "difference"}/>
              </Col>
              <Col span={record.type==='Entity' && domicilio.region !== undefined ?4:5}>
                {t("messages.aml.region")}
                <Input readOnly value={domicilio.region} className={actual && domicilio.region !== actual.region && "difference"}/>
              </Col>
              <Col span={record.type==='Entity' && domicilio.comuna !== undefined ?4:5}>
                {t("messages.aml.commune")}
                <Input readOnly value={domicilio.comuna} className={actual && domicilio.comuna !== actual.comuna && "difference"}/>
              </Col>
              <Col span={record.type==='Entity' && domicilio.direccion !== undefined ? 8:9}>
                {t("messages.aml.address")}
                <Input readOnly value={domicilio.direccion} className={actual && domicilio.direccion !== actual.direccion && "difference"}/>
              </Col>
            </Row>
        </div>
    );
};

export default Domicilio;